import StyledHeaderStatic from '/business/shared/components/widgets/header/__styled__/StyledHeaderStatic';
import HeaderDashboardSubNavMenu from '/business/shared/components/widgets/header/dashboard/HeaderDashboardSubNavMenu';
import type { ReactNode } from 'react';

type HeaderStaticProps = {
  showNav?: boolean;
  subTitle?: ReactNode;
  title?: ReactNode;
};

function HeaderStatic({ title = '', showNav = false, subTitle = '' }: HeaderStaticProps) {
  return (
    <>
      {showNav && (
        <>
          <HeaderDashboardSubNavMenu showBack />
        </>
      )}
      <StyledHeaderStatic>
        <h1>{title}</h1>
        {subTitle && <p>{subTitle}</p>}
      </StyledHeaderStatic>
    </>
  );
}

export default HeaderStatic;
